// @flow

import type { PropsSchema, EasyAction, BasicProps } from '../../type'

import { fetchVisitor as fengjrFetchVisitor } from 'projects/fengjr/visitor'
import { fetchVisitor as abroadFetchVisitor } from 'projects/abroad/visitor'
import computeData from '../hoc/computeData'
import { getPageInfo } from '../../pageInfo'
import * as React from 'react'

type Props = BasicProps;

@computeData({ includeVisible: false })
export default class SyncUserInfo extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'event',
      title: '成功',
      event: 'resolve'
    }
  ];

  static actions: EasyAction[] = [
    {
      title: '同步登录信息',
      name: 'syncUserInfo'
    }
  ];

  actionSyncUserInfo = () => {
    (getPageInfo().marketplace === 'abroad'
      ? abroadFetchVisitor
      : fengjrFetchVisitor)().then(visitor => {
        this.props.callActions('resolve', visitor)
      })
  };

  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/program/SyncUserInfo.js